import { useMemo } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { Booking } from "../../../../types/bookings";

export type BookingSelectorState = Booking & {
  isLoadingBookingDetails: boolean;
  isPaymentPlanApprovalSent: boolean;
};

export const useBookingSelector = (): BookingSelectorState => {
  const bookingDetails = useSelector<RootState, Booking | undefined>((state) => state?.newBooking?.bookingDetails);
  const isLoadingBookingDetails = useSelector<RootState, boolean>(
    (state) => state?.newBooking?.isLoadingBookingDetails,
  );

  return useMemo(() => {
    const { paymentPlanApproval } = bookingDetails ?? {};
    const isPaymentPlanApprovalSent = paymentPlanApproval === "sent";

    return {
      ...bookingDetails,
      isLoadingBookingDetails,
      isPaymentPlanApprovalSent,
    };
  }, [bookingDetails, isLoadingBookingDetails]);
};
